export const CONTACT_TYPES = {
  AccountantCpa: "Accountant/CPA",
  ArtAdvisor: "Art Advisor",
  ConciergeLifestyleManager: "Concierge/Lifestyle Manager",
  EstateAttorney: "Estate Attorney",
  ExecutiveAssistant: "Executive Assistant",
  ExternalFamilyOfficeCeoLead: "External Family Office CEO Lead",
  GeneralCounsel: "General Counsel",
  HomeManager: "Home Manager",
  HouseholdStaffMember: "Household Staff Member",
  InsuranceCompany: "Insurance Company",
  InvestmentPortfolioManager: "Investment Portfolio Manager",
  PersonalBanker: "Personal Banker",
  PhilanthropyAdvisor: "Philanthropy Advisor",
  PrivateSecurityTeamLead: "Private Security Team Lead",
  RealEstateSpecialist: "Real Estate Specialist",
  TaxAttorney: "Tax Attorney",
  TechnologyAndCybersecurityAdvisor: "Technology and Cybersecurity Advisor",
  WealthAdvisor: "Wealth Advisor"
} as const;

export type ContactType = typeof CONTACT_TYPES[keyof typeof CONTACT_TYPES];